export default __webpack_public_path__ + "static/media/b_listening_small.d1cdd860.png";